import { render, staticRenderFns } from "./viewDialog.vue?vue&type=template&id=46cb457f&scoped=true"
import script from "./viewDialog.vue?vue&type=script&lang=js"
export * from "./viewDialog.vue?vue&type=script&lang=js"
import style0 from "./viewDialog.vue?vue&type=style&index=0&id=46cb457f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cb457f",
  null
  
)

export default component.exports